require('html5-history-api');

module.exports = {

  replaceState: function(state, title, url) {
    if(window.history) {
      history.replaceState(state, title, url);

      if(title) {
        this.updateTitle(title);
      }
    }
  },

  updateTitle: function(title) {
    document.title = title;

    if(title.indexOf('|') !== -1) {
      title = title.substring(0, title.indexOf('|') - 1);
      SiteVars['page_title'] = title;
    }
  },

  getLocation: function() {
    return history.location || window.location;
  }

}